<template>
    <div class="delivery-allocated-devices">
        <el-form class="delivery-allocated-device-title" label-width="72px" :inline="true" size="mini">
            <el-col :span="12">
                <el-form-item :label="$t('suo_shu_chan_pin')">
                    <el-select :placeholder="$t('qing_shu_ru_dui_ying_de_chan_pin')"
                               class="delivery-allocated-device-input-filter"
                               filterable
                               clearable
                               remote
                               reserve-keyword
                               @change="loadDeviceSearch" :remote-method="querySearchAsync"
                               :loading="loading"
                               v-model="pagination.productUuid">
                        <el-option
                                v-for="item in products"
                                :key="item.productUuid"
                                :label="item.productName"
                                :value="item.productUuid">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item :label="$t('bian_ma_sou_suo')">
                    <el-input :placeholder="$t('qing_shu_ru_she_bei_bian_ma')" class="delivery-allocated-device-input-filter"
                              @change="loadDeviceSearch"
                              v-model="pagination.uuid"
                              clearable
                              prefix-icon="el-icon-search"></el-input>
                </el-form-item>
            </el-col>
        </el-form>
        <div class="delivery-allocated-device-data-list">
            <el-table :data="devices"
                      ref="multipleTable"
                      max-height="320px"
                      @select="listChange"
                      @select-all="handleBatch">
                <el-table-column type="selection">
                </el-table-column>
                <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid"></el-table-column>
                <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="name"></el-table-column>
                <el-table-column :label="$t('fen_pei_shi_jian')" align="center">
                    <template slot-scope="scope">
                        <span>{{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('chan_pin')" align="center" prop="productName" width="100"></el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                class="pagination"
                :current-page="pagination.curPage"
                :page-size="pagination.limit"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
        </el-pagination>
    </div>

</template>

<script>
    import {
        deviceAllocateUnion,
        deviceAllocateList,
        deviceQueryProduct
    } from '@/api/delivery/device/allocate'
    import {enterpriseAllName} from '@/api/factory/account/enterprise'
    export default {
        name: '',
        props: {
        },
        components: {},
        computed: {},
        mounted: function () {
            this.loadDevice()
        },
        data: function () {
            return {
                deliveries: [],
                devices: [],
                products: [],
                loading: false,
                pagination: {
                    productUuid: '',
                    uuid: '',
                    start: 0,
                    curPage: 1,
                    limit: 8,
                    total: 0,
                },
                allocatedEnterprise: {},
                delivery: {
                    devices: []
                }
            }
        },

        methods: {
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                deviceAllocateList(this.pagination).then(res => {
                    this.devices = res.data || []
                    this.$nextTick(function () {
                        this.judoCheck(this.devices)
                    })
                })
            },

            judoCheck(devices) {
                for (let j = 0; j < devices.length; j++) {
                    devices[j].checked = false
                }

                for (let j = 0; j < devices.length; j++) {
                    for (let i = 0; i < this.delivery.devices.length; i++) {
                        if (devices[j].uuid === this.delivery.devices[i]) {
                            this.$refs.multipleTable.toggleRowSelection(devices[j])
                            break
                        }
                    }
                }
                return devices
            },

            handleBatch(value) {
                for (let j = 0; j < this.devices.length; j++) {
                    for (let i = 0; i < this.delivery.devices.length; i++) {
                        if (this.devices[j].uuid === this.delivery.devices[i]) {
                            this.delivery.devices.splice(i, 1)
                        }
                    }
                }

                if (value.length !== 0) {
                    for (let j = 0; j < value.length; j++) {
                        this.delivery.devices.push(value[j].uuid)
                    }
                }
            },


            listChange(selection) {
                this.handleBatch(selection)
            },

            loadEnterprise() {
                let vue = this
                enterpriseAllName().then(res => {
                    vue.deliveries = res.data || []
                })
            },

            loadDevice(){
                let vue = this
                deviceAllocateUnion(this.pagination).then(res => {
                    vue.devices = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },
            loadDeviceSearch(){
                let vue = this
                this.pagination.curPage = 1
                this.pagination.start = 0
                deviceAllocateUnion(this.pagination).then(res => {
                    vue.delivery.devices = []
                    vue.devices = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },

            deviceAllocate(){
                return this.delivery.devices
            },
            querySearchAsync(queryString) {
                let vue = this
                vue.loading = true
                deviceQueryProduct({name: queryString}).then(res => {
                    vue.products = res.data || []
                    vue.loading = false
                })
            }
        },
    }
</script>

<style lang="scss">
    .delivery-allocated-devices {
        padding: $padding $padding-5;
        display: flex;
        flex-direction: column;
        .delivery-allocated-device-title {
            .delivery-allocated-device-input-filter {
                input {
                    border: none;
                    border-bottom: 1px solid $f_fiv_color;
                    font-size: $filter-font-size;
                    border-radius: 0;
                }
            }

            .delivery-allocated-device-status-filter {
                max-width: 124px;
                .el-input--suffix .el-input__inner {
                    padding-right: 0;
                }
            }

            .more {
                font-size: .6rem;
                height: 28px !important;
                line-height: 28px;
                display: table-cell;
                vertical-align: middle;
                text-align: center;

                span {
                    cursor: pointer;
                }
            }
        }
        .delivery-allocated-device-data-list {
            margin-top: $padding;
            flex: 1;

            .delivery-allocated-device-status {
                .delivery-allocated-device-info-img {
                }
                .delivery-allocated-device-info-detail {

                    p {
                        margin-bottom: $padding-5;
                    }
                    p:first-child {
                        font-size: .8rem;
                    }
                }
            }

            .delivery-allocated-device-address {
                p {
                    margin-bottom: $padding-5;
                }
            }
            .el-table {
                thead {
                    tr {
                        th {
                            border-bottom: 1px solid $border_sec_color;
                        }
                    }
                }

            }
            .el-table--group::after, .el-table--border::after, .el-table::before {
                background-color: transparent;
            }
            .el-table__row:hover {
                background-color: $bg_sec_color;
            }

        }

        .pagination {
            margin: $padding;
        }
    }

</style>
